var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77361 2.93764C8.29758 2.651 7.70209 2.651 7.22606 2.93764L6.88186 3.1449C6.0467 3.64779 5.10911 3.95639 4.13853 4.04783L3.92167 4.06826C3.49361 4.10859 3.1665 4.46796 3.1665 4.89792V5.99384C3.1665 7.84626 3.91856 9.6193 5.25039 10.9068L7.42064 13.0048C7.74364 13.3171 8.25603 13.3171 8.57904 13.0048L10.7493 10.9068C12.0811 9.61931 12.8332 7.84626 12.8332 5.99384V4.89792C12.8332 4.46796 12.5061 4.10859 12.078 4.06826L11.8611 4.04783C10.8906 3.95639 9.95298 3.64779 9.11781 3.1449L8.77361 2.93764Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.e934e4bf94bba3dbe39dae79be465f2e.svg";
export { ForwardRef as ReactComponent };